import { v4 as uuidv4 } from "uuid";
import checkBulletImage from "@circle-react-shared/BuilderUI/Assets/icons/check_bullet.png";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import { getBlockPrimaryStyleOptions } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/stylesHelpers";
import {
  createBlockquoteBlock,
  createH2Block,
  createPBlock,
  createUlBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getBorderRadiusOptions } from "@circle-react-shared/BuilderUI/utils/imgStyleHelpers";
import { getSizingOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import {
  getFontSizeOptions,
  getFontWeightOptions,
  getLineHeightOptions,
} from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import placeholderImage from "./homepage_block_5_default_image.png";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "EvergreenHomepageBlock5",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Guided by a strategist, not just a teacher",
        }),
        createPBlock({
          text: "This isn’t just instruction—it’s mentorship from someone who’s supported 300+ creators and educators in turning their expertise into structured, results-driven programs.",
        }),
      ],
    },
    leftContent: {
      prop: "children",
      type: "children",
      value: [
        createBlockquoteBlock({
          text: "“Our work is about building confidence, and real momentum. Inside Elevate, you’ll find expert support, smart frameworks, and a community that helps you grow a teaching business that truly reflects your purpose”",
          styles: {
            fontWeight: getFontWeightOptions("600"),
            fontSize: getFontSizeOptions("1.25rem"),
            lineHeight: getLineHeightOptions("1.5"),
          },
        }),
        createPBlock({
          text: "My coaching approach is rooted in learning science, solopreneur strategy, and clarity-first thinking—giving you a foundation to build offers that last, systems that scale, and content that transforms.",
          paragraphStyle: "p3",
        }),
        createUlBlock({
          items: [
            {
              text: "15+ years translating expertise into curriculum that scales",
              placeholder: checkBulletImage,
            },
            {
              text: "Over 300 creators launched through guided strategy",
              placeholder: checkBulletImage,
            },
            {
              text: "Builder of systems that support both scale and soul",
              placeholder: checkBulletImage,
            },
            {
              text: "Dedicated to helping educators become entrepreneurs",
              placeholder: checkBulletImage,
            },
          ],
        }),
      ],
    },
    rightContent: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: placeholderImage,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                maxHeight: "none",
                maxWidth: "none",
                width: "100%",
                height: "100%",
                minHeight: "auto",
                minWidth: "auto",
              },
            }),
            borderRadius: getBorderRadiusOptions({
              defaultValue: {
                border_left_top_radius: 20,
                border_left_bottom_radius: 20,
                border_right_top_radius: 20,
                border_right_bottom_radius: 20,
              },
            }),
          },
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getBlockPrimaryStyleOptions(),
      },
    },
  },
};
